function formatedCurrency(currency: number) {
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 0,
  })
    .format(currency)
    .replace('-', '');
}

export default formatedCurrency;
